import React from 'react'
import { LayoutBand, useContainerWidth, Divider } from '@fs/zion-ui'
import type { Person as PersonType } from '@fs/zion-tree-types'
import { Person } from '@fs/zion-person'
import StickyHeader from './StickyHeader'
import PersonPageTabs from '../PersonPageTabs'

type Props = {
  focusPerson: PersonType
  showTemple: boolean
}

export default function MobileMiniHeader({ focusPerson, showTemple }: Props): JSX.Element {
  const atSize = useContainerWidth()
  const componentSize = atSize({ default: 'sm', xxs: 'md', md: 'lg' })
  return (
    <StickyHeader>
      <div aria-hidden="true">
        <LayoutBand maxWidth="lg" marginY="nano" marginX="nano">
          <Person personObj={focusPerson} doNotLinkToPersonPage componentSize={componentSize} avatarSize="smaller" />
        </LayoutBand>

        <Divider />

        <LayoutBand maxWidth="lg">
          <PersonPageTabs growX showTemple={showTemple} />
        </LayoutBand>
      </div>
    </StickyHeader>
  )
}
